<div class="ph4 pt5-ns pt4 flex flex-column justify-around items-center">
    <p class="f3 b mv4">{{ titleLabel }}</p>
    <div class="w-80-ns center mv2">
        <app-blog-post *ngFor="let post of blogPosts" [post]="post"></app-blog-post>
    </div>
    <div class="w-100 w-80-ns pv2">
        <a href="https://medium.com/@f3igao" class="ruby no-underline underline-hover" target="_blank"
            (click)="sendClickEvent('to_medium')">{{ moreLabel }}</a>
    </div>
</div>